import { connect } from "react-redux"
import PropTypes from "prop-types"
import styled from "styled-components"

import { Outlet } from "react-router-dom"
import WrapContainer from "../WrapContainer"
import { setDefaultMetaData, setMetaData } from "../../../utils/metaData"
import { useEffect } from "react"

const ParentDiv = styled.div`
  max-width: 980px;
  margin-left: ${(props) => (props.isLarge ? "auto" : "20px")};
  margin-right: ${(props) => (props.isLarge ? "auto" : "20px")};
  margin-bottom: 80px;
  position: relative;
  padding: 0;
  div > h1 + div {
    text-align: center;
  }
  a {
    cursor: pointer;
  }
  img,
  iframe {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
  iframe {
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 20px auto;
  }
`

const FaqsContainer = ({ isLarge }) => {
  useEffect(() => {
    setMetaData({
      metaTitle: "Flossie FAQ's",
      metaDescription: "Flossie FAQs",
    })

    return () => setDefaultMetaData()
  })

  return (
    <WrapContainer loginRequired={false}>
      <ParentDiv isLarge={isLarge}>
        <Outlet />
      </ParentDiv>
    </WrapContainer>
  )
}

FaqsContainer.propTypes = {
  isLarge: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => ({
  isLarge: state.browser.greaterThan.large,
})

export default connect(mapStateToProps)(FaqsContainer)
